import React from 'react';
import Notify from './Notify';

/**
 * @param props
 * @deprecated Use `NotificationCenter.getInstance().notify()` directly instead
 */
export default function NotifyAndClose(props) {
    return <Notify showClose {...props} />;
}
